export enum PromotionalMessageType {
  Standard = 'standard',
  Custom = 'custom',
}
